import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=08e216a1&scoped=true&"
import script from "./Map.vue?vue&type=script&lang=js&"
export * from "./Map.vue?vue&type=script&lang=js&"
import style0 from "./Map.vue?vue&type=style&index=0&id=08e216a1&prod&lang=css&"
import style1 from "./Map.vue?vue&type=style&index=1&id=08e216a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e216a1",
  null
  
)

export default component.exports